import { useCallback } from 'react'
import { notification } from 'antd'
import { useEffect, useState, useRef } from 'react'
import ExpandedRow from './ExpandedRow'
import createColumns from './createColumns'
import { StyledTable, TableHeader } from './styledComponents'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { useTheme } from 'styled-components'

notification.config({
  placement: 'top',
  duration: 5,
})

const TexturingConfigTable = (props) => {
  const { t } = useTranslation()
  const theme = useTheme()

  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)
  const [expandedRowKeys, setExpandedRowKeys] = useState([])
  const [status, setStatus] = useState([false, false])
  const statusRef = useRef(status)
  const bookablePartsRef = useRef(status)

  useEffect(() => {
    // Update the statusRef when "status" changes
    statusRef.current = status
  }, [status])

  useEffect(() => {
    props.setConfigState(data.every((obj) => obj.value === true))
  }, [data])

  const updateDataSourceAndCheckButton = useCallback(() => {
    if (statusRef.current[1]) {
      if (status[1]) {
        setData((prev) => {
          const newDataSource = [...prev]
          for (let i in newDataSource) {
            if (status[1] === newDataSource[i].id)
              newDataSource[i].value = status[0]
          }
          return newDataSource
        })
      }
      statusRef.current = [false, -1]
    }
  }, [status, props])

  const updateBookableParts = useCallback(() => {
    if (props.bookableParts) {
      if (bookablePartsRef.current !== false) {
        for (let i in props.bookableParts.bookableParts) {
          props.bookableParts.bookableParts[i].value =
            props.rowDataRef.current[props.bookableParts.bookableParts[i].id]
              ?.status ?? status[0]
        }
        setExpandedRowKeys([props.bookableParts.bookableParts[0].id])
        setData(props.bookableParts.bookableParts)
        setLoading(false)
        bookablePartsRef.current = false
      }
    }
  }, [props.bookableParts, status, setData, setLoading])

  useEffect(() => {
    updateBookableParts()
  }, [updateBookableParts])

  useEffect(() => {
    updateDataSourceAndCheckButton()
  }, [updateDataSourceAndCheckButton])

  const onTableRowExpand = (expanded, record) => {
    const keys = []
    if (expanded) {
      keys.push(record.id)
    }
    setExpandedRowKeys(keys)
  }

  const getRecordStatus = (recordId) => {
    return data.find((item) => item.id === recordId)?.value
  }

  return (
    <div>
      <TableHeader></TableHeader>
      <StyledTable
        loading={loading}
        columns={createColumns(t, expandedRowKeys, onTableRowExpand, theme)}
        expandable={{
          expandRowByClick: true,
          expandIconAsCell: false,
          expandIconColumnIndex: -1,
          showExpandColumn: true,
          expandedRowRender: (record) => (
            <ExpandedRow
              record={record}
              setStatus={setStatus}
              setCurrentFormValues={props.setCurrentFormValues}
              getRecordStatus={getRecordStatus}
              rowDataRef={props.rowDataRef}
            />
          ),
          rowExpandable: () => true,
        }}
        dataSource={data}
        expandedRowKeys={expandedRowKeys}
        onExpand={onTableRowExpand}
        rowKey={(part) => part.id}
      />
    </div>
  )
}

TexturingConfigTable.propTypes = {
  setConfigState: PropTypes.func.isRequired,
  rowDataRef: PropTypes.object.isRequired,
  bookableParts: PropTypes.shape({
    bookableParts: PropTypes.array.isRequired,
  }),
}

export default TexturingConfigTable
